import { normalizeRelations, resolveRelations } from '../helpers';

const state = {
  allIds: [],
  byId: {}
};

const getters = {
  find: (state, _, __, rootGetters) => id =>
    resolveRelations(state.byId[id], ['order_deals'], rootGetters, {
      inCart: true
    }),
  list: (state, getters) => state.allIds.map(id => getters.find(id))
};

const actions = {
  addDeals: ({ commit, dispatch }, deals) => {
    deals.forEach(deal => {
      commit('add', normalizeRelations(deal, ['order_deals']));
      dispatch('cartOrderDeals/addOrderDeals', deal.order_deals || [], {
        root: true
      });
    });
  }
};

const mutations = {
  add: (state, deal) => {
    state.byId[deal.id] = deal;
    if (state.allIds.includes(deal.id)) return;
    state.allIds.push(deal.id);
  }
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
};
